import { Injectable } from '@angular/core';
import {Actions, Effect} from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import {AccountService} from "@services/account.service";
import {PaginationState, ShipmentTypes} from "@store/reducers/shipments.reducer";
import {UPDATE_SAVED_SHIPMENT,
  LOAD_SHIPMENTS_AFTER_REMOVAL, REMOVE_SHIPMENTS, SET_ACTIVE_SEARCH, ShipmentPageLoad,
  SnackbarOpen, LoadShipmentsAfterRemoval, SetFilteredShipments
} from "@store/actions";
import {ActionWithPayload, AppState} from "@store/reducers";
import {Store} from "@ngrx/store";
import {forkJoin} from "rxjs/observable/forkJoin";
import {Router} from "@angular/router";
import {UpdateSavedShipmentFail} from "@store/actions/shipments.action";
import 'rxjs/add/operator/map';

@Injectable()
export class ShipmentsEffects {
  constructor(
    private actions$: Actions,
    private accountService: AccountService,
    private store: Store<AppState>,
    private router: Router,
  ) {}

  @Effect() shipmentsRemove$ = this.actions$
    .ofType(LOAD_SHIPMENTS_AFTER_REMOVAL)
    .switchMap((action: ActionWithPayload<any>) => {
      let observable: Observable<PaginationState> = this.accountService.getSearchDraft({
        size: action.payload.current_page_size,
        page: action.payload.current_page
      });

      return observable.map((data: any) => new ShipmentPageLoad({
        type: action.payload.type,
        current_page_size: +data.per_page,
        current_page: +data.current_page,
        total: data.total,
        data: data.data,
      }))
        .catch((err: any) => Observable.throw(new Error(err)))
    });

  @Effect() filterShipments$ = this.actions$
    .ofType(SET_ACTIVE_SEARCH)
    .switchMap((action: ActionWithPayload<any>) => {
      const params = {
        [action.payload.type === ShipmentTypes.SAVED ? 'search' : 'shipment_ref']: action.payload.activeSearch,
        size: action.payload.current_page_size,
        page: action.payload.current_page
      };
      let observable: Observable<any>;
      switch (action.payload.type) {
        case ShipmentTypes.SAVED:
          observable = this.accountService.getSearchDraft(params);
          break;
        case ShipmentTypes.BOOKED:
          observable = this.accountService.getShipments({...params, statuses: ['CREATED', 'STORED', 'PRE_TRANSPORT', 'CONFIRMED']});
          break;
        case ShipmentTypes.ONGOING:
          observable = this.accountService.getShipments({...params, statuses: ['IN_TRANSIT', 'PICKUP', 'EXCEPTION', 'DESTINATION_HANDLING', 'FAILED']});
          break;
        case ShipmentTypes.DELIVERED:
          observable = this.accountService.getShipments({...params, statuses: ['DELIVERED']});
          break;
      }

      return observable.map((data: any) => {
        return new SetFilteredShipments({
          data: data.data,
          total: data.total,
          type: action.payload.type,
          activeSearch: action.payload.activeSearch,
          current_page_size: action.payload.current_page_size,
          current_page: action.payload.current_page
        });
      })
        .catch((err: any) => Observable.throw(new Error(err)));
    });

  @Effect() removeShipments$ = this.actions$
    .ofType(REMOVE_SHIPMENTS)
    .switchMap((action: ActionWithPayload<any>) => {
      return forkJoin(action.payload.ids.map((id) => this.accountService.removeSearchDraft(id)))
        .map((data: any) => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: `Shipment${action.payload.ids.length > 1 ? 's' : ''} successfully deleted.`,
              error: false,
            },
          }));
          return action.payload;
        })
        .catch((err: any) => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: `Shipment${action.payload.ids.length > 1 ? 's' : ''} could not be deleted.`,
              error: true,
            },
          }));
          return Observable.throw(new Error(err));
        }).finally(() => {
           this.store.dispatch(new LoadShipmentsAfterRemoval({
            type: ShipmentTypes.SAVED,
            current_page_size: action.payload.current_page_size,
            current_page: action.payload.current_page
          }));
        });
    });

  @Effect() updateSavedShipment = this.actions$
    .ofType(UPDATE_SAVED_SHIPMENT)
    .switchMap((action: ActionWithPayload<any>) => {
      const observable =  action.payload.search_id ?
        this.accountService.updateSearchDraft(action.payload, action.payload.search_id) :
        this.accountService.saveSearchDraft(action.payload);
      return observable
        .map(() => {
          return new SnackbarOpen({
            data: {
              message: 'Your shipment was successfully saved.',
              error: false,
            },
          });
        })
        .catch((err) => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: 'Shipment could not be saved.',
              error: true,
            },
          }));
          return Observable.of(new UpdateSavedShipmentFail());
        });
    });

}



// WEBPACK FOOTER //
// ./src/app/store/effects/shipments.effect.ts